import { useTranslation } from "react-i18next";
import { Tab } from "semantic-ui-react";

import { CommunicationLogReplacementCar } from "modules/AppointmentDetails/components/CommunicationLogReplacementCar";
import { AppointmentDetails, Content } from "modules/AppointmentDetails/components/DeskCommunicationLog/components";

import type { Appointment, DeskCommunication } from "models";
import type { ReactNode } from "react";

type CommunicationsProps = {
  appointment: Appointment;
  desk_communications: DeskCommunication[];
  defaultTabActiveIndex?: number;
};

type CommunicationPane = {
  menuItem: string;
  render: () => ReactNode;
};

export const Communications = ({ appointment, desk_communications, defaultTabActiveIndex = 0 }: CommunicationsProps) => {
  const panes: CommunicationPane[] = [];
  const { t } = useTranslation();

  desk_communications
    .sort((comm1, comm2) => comm1.created_on.localeCompare(comm2.created_on))
    .forEach((comm: DeskCommunication) => {
      panes.push({
        menuItem: comm.is_checking_out ? t("v8_desk_check_out", "Desk Check-out") : t("v8_desk_check_in", "Desk Check-in"),
        render: () => <Content appointment={appointment} comm={comm} />
      });
    });

  return panes.length > 0 ? (
    <>
      <AppointmentDetails appointment={appointment} />
      <CommunicationLogReplacementCar appointment={appointment} />
      <Tab menu={{ secondary: true }} panes={panes} defaultActiveIndex={defaultTabActiveIndex} />
    </>
  ) : null;
};
